<template>
    <top-users :users="allTimeLeaderboardUsers" :style="{ height: allTimeLeaderboardUsers.length === 1 ? '150px' : '' }" />
    <users-list :users="allTimeLeaderboardUsers" />
</template>



<script setup>

import { computed } from 'vue';
import { LeaderboardStore } from "@/store/LeaderboardStore";
import TopUsers from "@/components/Leaderboard/Top-Users.vue";
import UsersList from "@/components/Leaderboard/Users-List.vue";

const leaderboardStore = LeaderboardStore();

const allTimeLeaderboardUsers = computed(() => {
    return leaderboardStore.allTimeLeaderboard;
});

</script>